import React from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import useCan from '@shared/permissions/useCan';
import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import ListPageHeader from '@shared/ListPageHeader'
import InventoryHoldList from '@shared/inventory/InventoryHoldList'
import { inventoryHoldService } from '@services/operator/inventoryHoldService'

export default function List() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const can = useCan();
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()
  const canWrite = can('inventories:write')

  return (
    <div>
      <ListPageHeader
        items={['stocks', 'stocks.inventory_holds']}
        actions={
          canWrite && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate('/inventory_holds/new')}
            >
              {t('common.button.new')}
            </Button>
          )
        }
      />
      <InventoryHoldList
        service={inventoryHoldService}
        role="operator"
        merchants={merchants}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}
